<template>
    <div class="akmitem-modal">
        <div v-if="dataReady === true">
            <div class="i-header">
                <div class="i-site">
                    <div class="logo-box" v-if="site.attrs.logo.length > 0 ">
                        <a :href="site.attrs.url" target="_blank" rel="nofollow"><img v-bind:src="site.attrs.logo" :class="site.site"></a>
                    </div>
                </div>
                <div class="i-subs">
                    <div class="i-sub" v-bind:class="{'i-active': sindex === actSub}" v-for="(sub, sindex) in site['subs']" v-bind:key="sindex" @click="showSub(sindex)">
                        <span class="i-sub-title">{{sub['attrs']['cn']}}</span>
                    </div>
                </div>
            </div>
            <div class="i-content">
                <div class="singles" :style="{height: itemsHeight + 'px'}">
                    <div  v-for="(item, index) in actData.items" v-bind:key="index">
                        <a :href="['/go/' + item.iid]" class="i-a" target="_blank" v-if="item.title !== 'nullItem'">
                        <!--<button @click="gourl" class="i-a" target="_blank" v-if="item.title !== 'nullItem'">-->
                            <div class="single">
                                <span class="seq" v-bind:class="{highlight: item.rank < 4 }">{{item.rank}}</span>
                                <span class="title">{{item.title}}<span class="new-tag" v-show="item.new_tag">新</span></span>
                                <span class="ext" v-show="'more' in item">{{item.more}}</span>
                            </div>
                        </a>
                        <div class="single null" v-else>
                        </div>
                    </div>
                </div>
            </div>
            <div class="i-footer">
                <div class="i-hint">from <a :href="site.attrs.url" target="_blank" rel="nofollow">{{site.attrs.cn}}</a></div>
                <div class="i-op" v-bind:class="{'no-left': pageAttr[actSub]['curPage'] === 1, 'no-right': pageAttr[actSub]['curPage'] === pageAttr[actSub]['pageNum']}">
                    <div class="i-op-left" v-show="pageAttr[actSub]['curPage'] > 1" @click="prevPage()">
                        <div>
                            <img class="i-op-img" src="../assets/images/left-arrow.png">
                        </div>
                        <div>上一页</div>
                    </div>
                    <div class="i-op-right" v-show="pageAttr[actSub]['pageNum'] > 1 && pageAttr[actSub]['curPage'] < pageAttr[actSub]['pageNum'] " @click="nextPage()">
                        <div>下一页</div>
                        <div>
                            <img class="i-op-img" src="../assets/images/right-arrow.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
  import Vue from 'vue'
  export default {
    props: ['site', 'mheight'],
    name: "akmitemModal",
    data () {
      return {
        // subs调整输出为list，以实现排序效果
        actSub: '',
        actData: {
          display: 'single',
          itemNum: 0,
          items: []
        },
        pageAttr: {
        },
        //数据未加载好
        itemsHeight: 400,
        dataReady: false
      }
    },
    created(){
      //根据mheight计算single，double显示数量
      //减去margin-top, header footer
      this.itemsHeight = this.mheight - 10 - 60 - 50
      this.setSiteData()
      // window.addEventListener('click', eventHandler, false);
      // document.body.addEventListener('touchmove',this.bodyScroll,{passive: false});
    },
    updated:  function () {
      this.setSiteData()
    },
    // destroyed() {
    //   document.body.removeEventListener('touchmove',this.bodyScroll,{passive: false});
    // },
    methods: {
      // bodyScroll(event) {
      //   event.preventDefault();
      // },
      gourl: function () {
        // window.location.href = 'https://www.baidu.com'
        window.location.href = 'https://www.zhihu.com'
        // window.open('')

      },
      noOut: function (event) {
        // Only run for iOS full screen apps
        if (('standalone' in window.navigator) && window.navigator.standalone) {
          // Only run if link is an anchor and points to the current page
          if ( event.target.tagName.toLowerCase() !== 'a' ) return;
          // if ( event.target.tagName.toLowerCase() !== 'a' || event.target.hostname !== window.location.hostname || event.target.pathname !== window.location.pathname || !/#/.test(event.target.href) ) return;

          // Open link in same tab
          event.preventDefault();
          // window.location = event.target.href;
          window.location = 'https://www.zhihu.com';
        }
      },
      setSiteData: function (){
        if(this.dataReady === false){
          var _subs = this.site.subs
          for(var skey in _subs){
            // 默认显示第一个sub
            var _pageNum = 1;
            if(this.actSub === '') {
              this.actSub = parseInt(skey)
            }
            _pageNum = Math.ceil(_subs[skey]['items'].length / _subs[skey]['attrs']['display'])
            this.pageAttr[skey] = {
              pageNum:_pageNum,
              curPage: 1
            }
            for(var i = 0; i < _subs[skey]['items'].length; i++){
              _subs[skey]['items'][i]['rank'] = i + 1
            }
            this.site.subs = _subs
            if(this.actData.items.length === 0){
              this.actData = {
                display: _subs[skey]['attrs']['display'],
                items: _subs[skey]['items'].slice(0, _subs[skey]['attrs']['display'])
              }
            }
            //填充空白item数据便于排版使用
            var _nullNum = 0
            if(_subs[skey]['items'].length % _subs[skey]['attrs']['display'] !== 0){
              _nullNum = _subs[skey]['attrs']['display'] - _subs[skey]['items'].length % _subs[skey]['attrs']['display']
            }
            var j = 0
            while(j < _nullNum){
              _subs[skey]['items'].push({title: 'nullItem', seq: -1})
              j++
            }
          }
          this.dataReady = true
        }
      },
      showSub: function (sub) {
        this.actSub = sub
        var _itemNum = this.site['subs'][this.actSub]['attrs']['display']
        var _start = _itemNum * (this.pageAttr[this.actSub].curPage - 1)
        this.actData = {
          display: this.site['subs'][this.actSub]['attrs']['display'],
          items: this.site.subs[this.actSub]['items'].slice(_start , _start + _itemNum)
        }
      },
      nextPage: function () {
        // this.pageAttr[this.actSub].curPage = this.pageAttr[this.actSub].curPage + 1
        Vue.set(this.pageAttr[this.actSub], 'curPage', this.pageAttr[this.actSub].curPage + 1)
        var _itemNum = this.site['subs'][this.actSub]['attrs']['display']
        var _start = _itemNum * (this.pageAttr[this.actSub].curPage - 1)
        this.actData = {
          display: this.site['subs'][this.actSub]['attrs']['display'],
          items: this.site['subs'][this.actSub]['items'].slice(_start , _start + _itemNum)
        }
      },
      prevPage: function () {
        // this.pageAttr[this.actSub].curPage = this.pageAttr[this.actSub].curPage - 1
        Vue.set(this.pageAttr[this.actSub], 'curPage', this.pageAttr[this.actSub].curPage - 1)
        var _itemNum = this.site['subs'][this.actSub]['attrs']['display']
        var _start = _itemNum * (this.pageAttr[this.actSub].curPage - 1)
        this.actData = {
          display: this.site['subs'][this.actSub]['attrs']['display'],
          items: this.site.subs[this.actSub]['items'].slice(_start , _start + _itemNum)
        }
      }
    }
  }
</script>

<style lang="less">
    .akmitem-modal{
        /*width: 350px;*/
        /*height: 450px;*/
        /*margin-top: 10px;*/
        padding: 0 10px;
        margin: 10px 10px;
        background-color: #FFFFFF;
        border-radius: 5px;
        .i-header{
            display: flex;
            align-items: flex-end;
            justify-content: left;
            padding: 10px 0;
            border-bottom: 1px solid #f8f8f8;
            height: 60px;
            .i-site{
                flex: 1;
                font-size: 1.2rem;
                font-weight: bold;
                .logo-box{
                    height: 30px;
                    img{
                        height: 30px;
                        &.zhihu{
                            height: 25px;
                        }
                        &.cbo{
                            height: 25px;
                        }
                    }
                }
            }
            .i-subs{
                display: flex;
                align-items: flex-end;
                justify-content: left;
                /*padding: 0 10px;*/
                .i-sub{
                    font-size: 1rem;
                    position: relative;
                    margin-left: 20px;
                    cursor: pointer;
                    &.i-active{
                        font-weight: bold;
                        &:after{
                            content: "";
                            position: absolute;
                            display: block;
                            width: 100%;
                            border-bottom: 2px solid #3DB4F1;
                            left: 0;
                            bottom: -11px;
                            background-color: #D23023;
                        }
                    }
                }
            }
        }
        .i-content{
            padding: 10px 0;
            .singles{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                /*height: 300px;*/
                a:visited {
                    .single{
                        .title{
                            color: #999999;
                        }
                    }
                }
                .single{
                    /*height: 1rem;*/
                    /*padding: 15px 0;*/
                    display: flex;
                    align-items: center;
                    justify-content: left;
                    font-size: 1rem;
                    .seq{
                        color: #E2E2E2;
                        font-style: italic;
                        width: 30px;
                        &.highlight{
                            color: #3DB4F1;
                        }
                    }
                    .title{
                        flex: 1;
                        color: #333333;
                        .new-tag{
                            background-color: #3DB4F1;
                            font-size: 10px;
                            color: #FFFFFF;
                            padding: 0px 2px;
                            margin-left: 5px;
                        }
                    }
                    .ext{
                        color: #999999;
                    }
                }
            }
        }
        .i-footer{
            border-top:1px solid #f8f8f8;
            display: flex;
            flex-direction: row;
            padding: 15px 0;
            .i-hint{
                color: #999999;
                font-size: 0.8rem;
                flex: 1;
            }
            .i-op{
                display: block;
                /*flex-direction: row;*/
                /*align-items: center;*/
                color: #666666;
                width: 140px;
                font-size: 0.8rem;
                /*justify-content: flex-end;*/
                /*&.no-left{*/
                /*justify-content: flex-end;*/
                /*}*/
                /*&.no-right{*/
                /*justify-content: flex-start;*/
                /*}*/
                .i-op-img{
                    width: 10px;
                    display: block;
                }
                .i-op-left,.i-op-right{
                    cursor: pointer;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
                .i-op-left{
                    width: 50%;
                    float: left;
                    justify-content: left;
                    .i-op-img{
                        margin-right:3px;
                    }
                }
                .i-op-right{
                    width: 50%;
                    float: right;
                    justify-content: flex-end;
                    .i-op-img{
                        margin-left:3px;
                    }
                }
                /*.i-op-right{*/
                /*margin-left: 30px;*/
                /*}*/
            }
        }
    }

</style>